const plugin = require('tailwindcss/plugin');

module.exports = {
  content: [
    './storage/framework/views/*.php',
    './resources/views/**/*.blade.php',
    './node_modules/@braid/vue-formulate/**/*.{js,vue}',
    './node_modules/@cone2875/vue-formulate-select/**/*.{js,vue}',
    './resources/js/funnels/**/*.{js,vue,ts,jsx,tsx}',
    './resources/js/web/**/*.{js,vue,ts,jsx,tsx}',
    './config/*.php',
  ],
  safelist: ['btn', 'btn-primary', 'btn-lg'],
  theme: {
    screens: {
      xxs: '320px',
      xs: '480px',
      sm: '640px',
      md: '768px',
      lg: '996px',
      xl: '1320px',
      '2xl': '1536px',
      short: { raw: '(max-height: 719px)' },
      'short-lg': { raw: '(max-height: 768px) and (max-width: 1319px)' },
      'short-xl': { raw: '(max-height: 730px)' },
      tall: { raw: '(min-height: 720px)' },
    },
    colors: {
      transparent: 'transparent',
      current: 'currentColor',
      'brand-primary': {
        main: '#FFB700',
        darkest: '#C88F00',
        dark: '#DCA00A',
        medium: '#EAB226',
        DEFAULT: '#EAB226',
        light: '#FBD44C',
        lighter: '#FFC65F',
        soft: '#FFD58D',
        softer: '#FFE4B5',
        lightest: '#FAEDCD',
        ultralight: '#FFF8ED',
      },

      'brand-secondary': {
        darkest: '#051531',
        dark: '#10213E',
        medium: '#1F2F4B',
        DEFAULT: '#1F2F4B',
        light: '#263858',
        lightest: '#475A7D',
      },

      support: {
        darkest: '#6001AB',
        darker: '#0000FF',
        dark: '#009AFA',
        medium: '#81C5EE',
        DEFAULT: '#81C5EE',
        light: '#DBEEFA',
        lightest: '#EDF7FD',
      },

      'gradient-summer': {
        start: '#F6A229',
        end: '#F2DA5D',
        mole: '#F4C95C',
      },

      'gradient-summer-v2': {
        start: '#F3AF30',
        end: '#FBD44C',
      },

      'gradient-winter': {
        start: '#003FD8',
        'start-light': '#009AFA',
        end: '#9510FE',
      },

      imagin: {
        light: '#E2E2E0',
      },

      neutral: {
        superdark: '#161616',
        superdark2: '#2E2E2E',
        ultradark: '#111827',
        darkest: '#1F2937',
        darker: '#484848',
        dark: '#4B5563',
        semidark: '#6B7280',
        mediumgray: '#636363',
        medium: '#9CA3AF',
        mediumlight: '#9E9E9E',
        yellowish: '#BEBEBE',
        DEFAULT: '#ADADAD',
        lightdark: '#BEBEBE',
        semilight: '#D1D5DB',
        lightgray: '#DEDEDE',
        light: '#E5E7EB',
        lighter: '#F8F8F8',
        lightest: '#F3F4F6',
        ultralight: '#F9FAFB',
        superlight: '#FCFCFC',
        white: '#FFFFFF',
        grayish: '#A7B2C4',
        novagray: '#94A3B8',
      },

      feedback: {
        error: {
          dark: '#8C0002',
          medium: '#D80003',
          DEFAULT: '#D80003',
          soft: '#E00303',
          softer: '#FF7979',
          light: '#FF8D6E',
          lightest: '#FFB29D',
        },
        info: {
          dark: '#009ED0',
          medium: '#83C8DE',
          DEFAULT: '#83C8DE',
          light: '#D1E6ED',
        },
        alert: {
          dark: '#E0B008',
          medium: '#F7D251',
          DEFAULT: '#F7D251',
          soft:'#FFEBC8',
          light: '#F9EDC4',
          lightest: '#FFFBEB',
        },
        success: {
          dark: '#09945A',
          medium: '#0CC175',
          DEFAULT: '#0CC175',
          light: '#68EA9C',
          soft: '#86EFAC',
          lightest: '#ecfdf5',
        },
      },

      fotocasa: {
        primary: '#303AB2',
        secondary: {
          dark: '#2B35A1',
          medium: '#DBDCF0',
          light: '#F4F4FB',
        },
      },
    },
    borderRadius: {
      none: '0px',
      quark: '4px',
      s: '6px',
      sm: '8px',
      md: '12px',
      l: '16px',
      lg: '30px',
      pill: '2em',
      circular: '100%',
    },
    borderWidth: {
      none: '0px',
      hairline: '1px',
      thin: '2px',
      thick: '4px',
      thickest: '12px',
      bulky: '32px',
    },
    spacing: {
      '0': 0,
      quark: '0.25rem',
      nano: '0.5rem',
      micro: '0.75rem',
      xxxs: '1rem',
      xxs: '1.5rem',
      xs: '2rem',
      sm: '2.5rem',
      md: '3rem',
      lg: '3.5rem',
      xl: '4rem',
      xxl: '5rem',
      xxxl: '7.5rem',
      huge: '10rem',
      giant: '12.5rem',
    },
    fontFamily: {
      base: 'Roboto',
      highlight: 'Mont',
      fotocasa: 'Open sans',
      main: 'Onest',
    },
    fontSize: {
      caption: '0.625rem',
      tiny: '0.75rem',
      nano: '0.875rem',
      xs: '1rem',
      sm: '1.125rem',
      md: '1.375rem',
      lg: '1.5rem',
      xl: '2rem',
      huge: '2.5rem',
      giant: '3.125rem',
      display: '3.75rem',
    },
    fontWeight: {
      black: '900',
      extrabold: '800',
      bold: '700',
      semibold: '600',
      medium: '500',
      regular: '400',
      light: '300',
      extralight: '200',
      thin: '100',
    },
    lineHeight: {
      base: '1',
      short: '1.25',
      medium: '1.35',
      long: '1.5',
    },
    extend: {
      maxWidth: {
        content: '460px',
        'content-big': '705px',
      },
      dropShadow: {
        light: '0px 4px 14px rgba(1, 1, 1, 0.04)',
      },
    },
  },
  corePlugins: {
    container: false,
  },
  plugins: [
    plugin(require('./resources/tailwind/utilities/text-styles.js')),
    plugin(require('./resources/tailwind/utilities/paddings.js')),
    plugin(require('./resources/tailwind/utilities/layout.js')),
    plugin(require('./resources/tailwind/plugins/icons.js')),
    plugin(require('./resources/tailwind/plugins/buttons.js')),
  ],
};
